import { render, staticRenderFns } from "./FormCroPromotionDifferentBranch.vue?vue&type=template&id=b63a7364&scoped=true&lang=html&"
import script from "./FormCroPromotionDifferentBranch.vue?vue&type=script&lang=js&"
export * from "./FormCroPromotionDifferentBranch.vue?vue&type=script&lang=js&"
import style0 from "./FormCroPromotionDifferentBranch.vue?vue&type=style&index=0&id=b63a7364&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b63a7364",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VBtn,VCardActions,VCol,VContainer,VForm,VRow,VSpacer})
